import { render, staticRenderFns } from "./NotificationsCard.vue?vue&type=template&id=d87ed7d8&scoped=true"
import script from "@/components/notifications-card/NotificationsCard.ts?vue&type=script&lang=ts&external"
export * from "@/components/notifications-card/NotificationsCard.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/notifications-card/notifications-card.scss?vue&type=style&index=0&id=d87ed7d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87ed7d8",
  null
  
)

export default component.exports